export const FETCH_CHANNEL = 'views/users/FETCH_CHANNEL'
export const FETCH_CHANNEL_USER = 'views/users/FETCH_CHANNEL_USER'

